import PropTypes from "prop-types";

/**
 * Filter Option Shape
 * Shape for dropdown/select filter options
 *
 * @typedef {Object} FilterOption
 * @property {string} label - Display text for the option (required)
 * @property {string|number} value - Option value (required)
 * @property {boolean} [disabled] - Whether option is disabled/unselectable
 */
export const filterOptionShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  disabled: PropTypes.bool,
});
